document.addEventListener('DOMContentLoaded', async () => {
  if (window.location.pathname !== '/pages/start-a-custom-order') return;

  const form = document.querySelector('form[action*="/contact"]');
  if (!form) return;

  const submit = form.querySelector('button[type="submit"]');
  const notes = form.querySelector('[name="contact[body]"]');
  const comments = form.querySelector('#custom-order-comments');

  const preview = document.createElement('div');
  preview.id = 'custom-order-cart-preview';
  preview.style.margin = '1.5rem 0';
  preview.style.padding = '1rem';
  preview.style.border = '1px solid rgba(0,0,0,.15)';
  preview.style.borderRadius = '8px';

  try {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    const cart = await response.json();

    if (!cart.items || cart.items.length === 0) {
      preview.innerHTML = '<strong>Your cart is empty.</strong><p>Add the hats, colors, and quantities you want, then return here to submit your custom order.</p>';
      form.prepend(preview);
      if (submit) submit.disabled = true;
      return;
    }

    const money = (cents) => new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: cart.currency || 'USD'
    }).format((cents || 0) / 100);

    const lines = cart.items.map((item) => {
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? ' — ' + item.variant_title
        : '';
      return `${item.quantity} × ${item.product_title}${variant} — ${money(item.final_line_price)}`;
    });

    preview.innerHTML =
      '<strong>Items included in this custom-order request</strong><ul>' +
      cart.items.map((item) => {
        const variant = item.variant_title && item.variant_title !== 'Default Title'
          ? ' — ' + item.variant_title
          : '';
        return `<li>${item.quantity} × ${item.product_title}${variant}</li>`;
      }).join('') +
      '</ul><p><strong>Cart total:</strong> ' + money(cart.total_price) + '</p>';

    form.prepend(preview);

    const cartSummary =
      'CART CUSTOM ORDER REQUEST\n' +
      lines.map((line) => '- ' + line).join('\n') +
      '\nCart total: ' + money(cart.total_price);

    form.addEventListener('submit', () => {
      if (!notes) return;
      const customerComments = comments?.value.trim() || '';
      notes.value = cartSummary + (customerComments ? '\n\nCUSTOMER COMMENTS\n' + customerComments : '');
    }, { once: true });
  } catch (error) {
    preview.innerHTML = '<strong>We could not load your cart.</strong><p>Please return to your cart and try again.</p>';
    form.prepend(preview);
    if (submit) submit.disabled = true;
  }
});